import { PromotionsDaFieldsFragment } from '../ProductPageAccordion/PromotionsDaFields.gql'
import { PromotionAlert } from './PromotionAlert'

export type PromotionMessageProps = {
  cartPromotionQty: number
  cartItemQty?: number
  qty?: number
}

export function PromotionMessage(props: PromotionMessageProps & PromotionsDaFieldsFragment) {
  const {
    label_percent,
    label_qty,
    promotion_type,
    promotion_name,
    cartPromotionQty,
    cartItemQty = 0,
    qty = 0,
  } = props

  if (!label_qty || !label_percent) return null

  const totalDiscount = label_qty
    ? Math.round(label_percent * label_qty)
    : Math.round(label_percent * 1)

  let requiredQuantity = label_qty

  const remainingForPromotion = requiredQuantity - (cartPromotionQty % requiredQuantity)
  const showMessage = cartPromotionQty % requiredQuantity !== 0

  if (cartPromotionQty >= requiredQuantity) {
    requiredQuantity = cartPromotionQty + remainingForPromotion
  }

  const showNextPromotionMessage = cartItemQty + qty + remainingForPromotion <= 10
  if (!showMessage || !showNextPromotionMessage) return null

  const message = (
    <PromotionAlert promotionName={promotion_name} remainingForDiscount={remainingForPromotion} />
  )

  switch (promotion_type) {
    case 'PERCENTAGE_DISCOUNT':
      if (label_qty && label_qty > 1) {
        if (totalDiscount === 0 || totalDiscount === 50 || totalDiscount === 100) {
          return message
        }
      }
      return message
    case 'PERCENTAGE_DISCOUNT_CHEAPEST':
    case 'FIXED_PRICE':
      return message
    default:
      return null
  }
}
